import { VoltButton } from '@/components/ui/VoltButton';
import { GhostButton } from '@/components/ui/GhostButton';
import { ProseChip } from '@/components/ui/ProseChip';

export function Home() {
  return (
    <div className="max-w-5xl mx-auto px-4 md:px-8">
      {/* Hero */}
      <section className="py-16 md:py-24 text-center">
        <div className="animate-fade-in-up">
          <ProseChip style="accent" className="mb-6">WEB VERSION</ProseChip>
          <h1 className="font-display text-5xl md:text-7xl font-medium tracking-tight text-[var(--color-text)] mb-6">
            Mango
          </h1>
          <p className="text-lg md:text-xl text-[var(--color-muted)] max-w-2xl mx-auto mb-10 leading-relaxed">
            Make Twilio calls, send SMS, and manage your contacts — right from your browser.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
            <VoltButton>Get Started</VoltButton>
            <GhostButton>Learn More</GhostButton>
          </div>
        </div>
      </section>

      {/* Bento Grid */}
      <section className="py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* Calls */}
          <div className="rounded-3xl p-6 bg-[var(--color-surface)] border border-[var(--color-border)] shadow-card hover:-translate-y-1 transition-all duration-200 lg:col-span-2">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-10 h-10 rounded-xl bg-[var(--color-volt)] flex items-center justify-center text-black text-lg shrink-0">📞</div>
              <div>
                <h3 className="font-display text-xl font-medium text-[var(--color-text)] mb-1">Twilio Calls</h3>
                <p className="text-[var(--color-muted)] text-sm leading-relaxed">
                  Make and receive calls directly in your browser. Full call controls, recording, and real-time status.
                </p>
              </div>
            </div>
            <div className="flex gap-2 mt-4">
              <ProseChip style="outlined">HD Audio</ProseChip>
              <ProseChip style="surface">Recording</ProseChip>
            </div>
          </div>

          {/* Messages */}
          <div className="rounded-3xl p-6 bg-[var(--color-surface)] border border-[var(--color-border)] shadow-card hover:-translate-y-1 transition-all duration-200">
            <div className="w-10 h-10 rounded-xl bg-[var(--color-volt)] flex items-center justify-center text-black text-lg mb-4 shrink-0">💬</div>
            <h3 className="font-display text-xl font-medium text-[var(--color-text)] mb-1">SMS & RCS</h3>
            <p className="text-[var(--color-muted)] text-sm leading-relaxed">
              Send and receive text messages. Full conversation threads with delivery status.
            </p>
          </div>

          {/* Contacts */}
          <div className="rounded-3xl p-6 bg-[var(--color-surface)] border border-[var(--color-border)] shadow-card hover:-translate-y-1 transition-all duration-200">
            <div className="w-10 h-10 rounded-xl bg-[var(--color-volt)] flex items-center justify-center text-black text-lg mb-4 shrink-0">👥</div>
            <h3 className="font-display text-xl font-medium text-[var(--color-text)] mb-1">Contacts</h3>
            <p className="text-[var(--color-muted)] text-sm leading-relaxed">
              Manage your phonebook. Import, search, and organize contacts seamlessly.
            </p>
          </div>

          {/* Settings */}
          <div className="rounded-3xl p-6 bg-[var(--color-surface)] border border-[var(--color-border)] shadow-card hover:-translate-y-1 transition-all duration-200 lg:col-span-2">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-xl bg-[var(--color-volt)] flex items-center justify-center text-black text-lg shrink-0">⚙️</div>
              <div>
                <h3 className="font-display text-xl font-medium text-[var(--color-text)] mb-1">Twilio Setup</h3>
                <p className="text-[var(--color-muted)] text-sm leading-relaxed">
                  Connect your Twilio account in seconds. Manage phone numbers, configure SIP, and monitor usage.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Volt CTA */}
      <section className="py-16 mb-16">
        <div className="rounded-3xl bg-[var(--color-volt)] p-8 md:p-12 text-center">
          <h2 className="font-display text-3xl md:text-4xl font-medium text-black tracking-tight mb-4">
            Ready to call?
          </h2>
          <p className="text-black/70 text-base mb-8 max-w-lg mx-auto">
            Connect your Twilio account and start making calls from your browser in under a minute.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 max-w-sm mx-auto">
            <button className="w-full py-4 px-6 rounded-lg bg-black text-white font-display text-sm font-medium uppercase tracking-[0.15em] active:scale-[0.97] transition-all duration-100 cursor-pointer">
              Get Started
            </button>
            <button className="w-full py-4 px-6 rounded-lg bg-transparent text-black border border-black/20 font-display text-sm font-medium uppercase tracking-[0.15em] active:scale-[0.97] transition-all duration-100 cursor-pointer hover:bg-black/5">
              Download iOS
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
